export const LOGGED_IN_CANDIDATE = 'LoggedIn Candidate';
export const ADS_CONSENT_STORAGE_KEYS = ['ad_storage', 'ad_personalization', 'ad_user_data'];
export const ANALYTICS_CONSENT_STORAGE_KEYS = ['analytics_storage'];
